import { Fragment } from "react";
import { useSelector } from "react-redux";
import { CanvasChildrenProps } from "../../../components/Canvas/CanvasContainer";
import { selectChannelsForD3, selectRangeWithUnits } from "../../../store/freq-analysis/selectors";
import TechnologyChannelList from "../../../components/Canvas/TechnologyChannelList";
import { convertToHz } from "../../../helpers/converters/frequency";

type TechnologyLineListForCanvasProps = {

} & CanvasChildrenProps;

const TECHNOLOGY_DATA_Y_OFFSET = 100;
const TECHNOLOGY_DATA_Y_HEIGHT = 180;

function calculateCanvasHeight(technologyCount: number) {
  return TECHNOLOGY_DATA_Y_HEIGHT * technologyCount + 20;
}

const TechnologyLineListForCanvas = (props: TechnologyLineListForCanvasProps) => {
  const data = useSelector(selectChannelsForD3);
  const range = useSelector(selectRangeWithUnits);
  const rawFrequencyFrom = convertToHz(range[0]);
  const rawFrequencyTo = convertToHz(range[1]);

  const canvasWidthInHz = rawFrequencyTo - rawFrequencyFrom;

  return (
    <g className="technology-text-list">
      {
        data.map((technology, index) => {
          const offset = (index * TECHNOLOGY_DATA_Y_HEIGHT) + TECHNOLOGY_DATA_Y_OFFSET;
          return (
            <Fragment key={technology.technologyConfigurationId}>
              <text
                x={20}
                y={offset}
                fontSize="10px"
              >
                {technology.technologyName}
              </text>
              <TechnologyChannelList
                channelList={technology.channels}
                offset={offset}
                canvasWidthInHz={canvasWidthInHz}
                startFrequency={rawFrequencyFrom}
                {...props}
              />
            </Fragment>
          )
        })
      }
    </g>
  )
}

TechnologyLineListForCanvas.calculateCanvasHeight = calculateCanvasHeight;

export default TechnologyLineListForCanvas;